/**
 * Ziran India — Product card interactions
 * Add-to-cart success feedback on card buttons
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  function handleSubmit(event) {
    var form = event.target;
    if (!form.closest('.zi-card')) return;

    var button = form.querySelector('button[type="submit"]');
    if (!button) return;

    var label = button.querySelector('.zi-btn__label');
    var success = button.querySelector('.zi-btn__success');
    if (!label || !success) return;

    var observer = new MutationObserver(function () {
      if (button.classList.contains('loading')) return;
      label.classList.add('hidden');
      success.classList.remove('hidden');
      success.classList.add('visible');
      button.disabled = true;

      setTimeout(function () {
        label.classList.remove('hidden');
        success.classList.remove('visible');
        success.classList.add('hidden');
        button.disabled = false;
      }, 1800);

      observer.disconnect();
    });

    observer.observe(button, { attributes: true, attributeFilter: ['class'] });
  }

  ready(function () {
    document.addEventListener('submit', function (event) {
      if (event.target.matches('.zi-card form[data-type="add-to-cart-form"]')) {
        handleSubmit(event);
      }
    });
  });
})();
